function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { ChangeAtBlurWrapper } from './change-at-blur-wrapper.component';
/**
 * This HOC adds an optional boolean prop 'changeAtBlur' to a field component
 * If 'changeAtBlur' is true onChange will be invoked only once, just before
 * invoking onBlur, and only if the value actually changed.
 *
 * The wrapped field component receives a boolean prop 'dirty' that is true
 * when the value has changed and the component onChange was not invoked yet.
 *
 * NOTE: onChange receives the new value and not an Event object.
 *
 */

export function changeAtBlur(WrappedComponent) {
  return function (props) {
    var changeAtBlurProp = props.changeAtBlur,
        others = _objectWithoutProperties(props, ["changeAtBlur"]);

    if (changeAtBlurProp) {
      return (
        /*#__PURE__*/
        React.createElement(ChangeAtBlurWrapper, _extends({
          WrappedComponent: WrappedComponent
        }, others))
      );
    }

    return (
      /*#__PURE__*/
      React.createElement(WrappedComponent, others)
    );
  };
}